export interface interactionsHistory {
  interactionId: number;
  media: string;
  contactTrackingId: string;
  contactRequest: string;
  agentName: string;
  status: string;
  date: string;
  endTime: string;
  skill: string;
  campaign: string;
  disposition: string;
  autoSummary: string;
}

export const interactionsHistoryListData: interactionsHistory[] = [
  {
    interactionId: 22073581,
    media: 'Voice',
    contactTrackingId: '423-INCL-0246',
    contactRequest: 'Airline Customer Service',
    agentName: 'Agent Smith',
    status: 'open',
    date: new Date(
      new Date(Date.now() - 86400000).setHours(14, 10, 0, 0)
    ).toISOString(),
    endTime: '03:00:00 pm',
    skill: 'Virtual_Agent_QC',
    campaign: 'LCID_A',
    disposition: 'AGENT-CUST RPC 30',
    autoSummary:
      'Customer called in about their damaged luggage, we went in and reviewed the status. I let them know I’d be following up with them.',
  },
  {
    interactionId: 22073582,
    media: 'Email',
    contactTrackingId: '78-EMAIL-5S98',
    contactRequest: 'Question about my luggage',
    agentName: 'Agent Kapoor',
    status: 'closed',
    date: new Date(
      new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).setHours(8, 1, 0, 0)
    ).toISOString(),
    endTime: '09:43:12 am',
    skill: 'Virtual_Agent_QC',
    campaign: 'LCID_A',
    disposition: 'AGENT-CUST RPC 30',
    autoSummary:
      'Customer called in about their damaged luggage, we went in and reviewed the status. I let them know I’d be following up with them.',
  },
  {
    interactionId: 22073583,
    media: 'SMS',
    contactTrackingId: '897-OTVO-7455',
    contactRequest: 'Channel added',
    agentName: 'Agent Tiwari',
    status: 'closed',
    date: new Date(
      new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).setHours(10, 30, 0, 0)
    ).toISOString(),
    endTime: '11:08:10 am',
    skill: 'Virtual_Agent_QC',
    campaign: 'LCID_A',
    disposition: 'AGENT-CUST RPC 30',
    autoSummary:
      'Customer called in about their damaged luggage, we went in and reviewed the status. I let them know I’d be following up with them.',
  },
  {
    interactionId: 22073584,
    media: 'Chat',
    contactTrackingId: '897-267-5678',
    contactRequest: 'Customer Service',
    agentName: 'Agent Franciso',
    status: 'closed',
    date: new Date(
      new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).setHours(8, 30, 0, 0)
    ).toISOString(),
    endTime: '09:15:00 am',
    skill: 'Virtual_Agent_QC',
    campaign: 'LCID_A',
    disposition: 'AGENT-CUST RPC 30',
    autoSummary:
      'Customer called in about their damaged luggage, we went in and reviewed the status. I let them know I’d be following up with them.',
  },
  {
    interactionId: 22073585,
    media: 'Voice',
    contactTrackingId: '423-INCL-0246',
    contactRequest: 'Cell Phone Number Edit',
    agentName: 'Agent Smith',
    status: 'closed',
    date: new Date(
      new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).setHours(12, 10, 0, 0)
    ).toISOString(),
    endTime: '12:48:10 pm',
    skill: 'Virtual_Agent_QC',
    campaign: 'LCID_A',
    disposition: 'AGENT-CUST RPC 30',
    autoSummary:
      'Customer called in about their damaged luggage, we went in and reviewed the status. I let them know I’d be following up with them.',
  },
  {
    interactionId: 22073586,
    media: 'Email',
    contactTrackingId: '456-EMAIL-6245',
    contactRequest: 'Tickets Purchased',
    agentName: 'Service Bot',
    status: 'closed',
    date: new Date(
      new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).setHours(17, 15, 0, 0)
    ).toISOString(),
    endTime: '05:22:10 pm',
    skill: 'Virtual_Agent_QC',
    campaign: 'LCID_A',
    disposition: 'AGENT-CUST RPC 30',
    autoSummary:
      'Customer called in about their damaged luggage, we went in and reviewed the status. I let them know I’d be following up with them.',
  },
];
